/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Save_20percentInputs */

const en_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save 20%`)
};

const es_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorra 20%`)
};

const fr_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Économisez 20 %`)
};

const de_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20% sparen`)
};

const ja_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20%割引`)
};

const zh_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节省 20%`)
};

const ar_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وفر 20%`)
};

const id_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemat 20%`)
};

const it_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risparmia il 20%`)
};

const ru_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скидка 20%`)
};

const pt_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economize 20%`)
};

const ko_save_20percent = /** @type {(inputs: Save_20percentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20% 절약`)
};

/**
* | output |
* | --- |
* | "Save 20%" |
*
* @param {Save_20percentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const save_20percent = /** @type {((inputs?: Save_20percentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Save_20percentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_save_20percent(inputs)
	if (locale === "es") return es_save_20percent(inputs)
	if (locale === "fr") return fr_save_20percent(inputs)
	if (locale === "de") return de_save_20percent(inputs)
	if (locale === "ja") return ja_save_20percent(inputs)
	if (locale === "zh") return zh_save_20percent(inputs)
	if (locale === "ar") return ar_save_20percent(inputs)
	if (locale === "id") return id_save_20percent(inputs)
	if (locale === "it") return it_save_20percent(inputs)
	if (locale === "ru") return ru_save_20percent(inputs)
	if (locale === "pt") return pt_save_20percent(inputs)
	return ko_save_20percent(inputs)
});